// extracted by mini-css-extract-plugin
module.exports = {"map":"ThreeTestPage_map__24eCv","wrapper":"ThreeTestPage_wrapper__1cGgQ","frame":"ThreeTestPage_frame__2_SP3","fade-out":"ThreeTestPage_fade-out__sT1aw"};